import React, { useMemo, useEffect } from 'react';
import { useLocation } from 'react-router';
import { logoComponentsByEcommerce } from '../../components/units/logoComponents';
import { motion } from 'framer-motion';
import { fadeInAndUpNoDelay } from '../../services/shared/animation.service';
import {
  setEcommerceURL,
  capitalizeFirstLetter,
} from '../../services/shared/utils.service';
import { customerName } from '../../data/InfoSource';
import errorIcon from '../../assets/alertErrorIcon.svg';

export const InstallFail = () => {
  const location = useLocation();
  const ecommerce = setEcommerceURL(location);
  const LogoComponent = logoComponentsByEcommerce[ecommerce];

  useEffect(() => {
    document.title = `${customerName} - ${capitalizeFirstLetter(
      ecommerce
    )} - Installation Failed`;
  }, [ecommerce]);

  const errorMessage = useMemo(() => {
    try {
      const queryParams = new URLSearchParams(location.search);
      const message = queryParams.get('errorMessage');

      if (message && message.trim() !== '') {
        return decodeURIComponent(message).trim();
      }
    } catch (error) {
      console.error('Error parsing URL parameters:', error);
    }
    const platformName = capitalizeFirstLetter(ecommerce);
    return `An unexpected error occurred during ${platformName} installation.`;
  }, [location.search, ecommerce]);

  return (
    <div className="container-fluid" id="installFail">
      <div className="row">
        <div className="col-12">
          <motion.div
            className="fail-wrapper"
            variants={fadeInAndUpNoDelay}
            initial="hidden"
            animate="visible"
          >
            {/* Logo Section */}
            <div className="logo-section">
              {LogoComponent ? <LogoComponent ecommerce={ecommerce} /> : null}
            </div>

            {/* Error Content */}
            <div className="error-content">
              <div className="error-icon-wrapper">
                <img src={errorIcon} alt="Error" className="error-icon" />
              </div>

              <h1 className="error-title">Something went wrong!</h1>
              <h2 className="error-subtitle">
                Close this tab and try installing again.
              </h2>

              {/* Error Message Box */}
              <div className="error-message-box">
                <p className="error-message">{errorMessage}</p>
              </div>

              {/* Support Contact */}
              <div className="support-section">
                <p className="support-text">
                  If the problem persists, please contact Pickit support at
                  <a
                    href="https://pickit.com.ar/"
                    className="support-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {' '}
                    here
                  </a>
                  .
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};
